import { render, staticRenderFns } from "./SpecialCoin.vue?vue&type=template&id=08a15698&"
import script from "./SpecialCoin.vue?vue&type=script&lang=ts&"
export * from "./SpecialCoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports